const MultiMetric = () =>
    import(
        '@/components/Dashboard/common/WidgetSettingPanel/reactOptions/multiMetric'
    );

import { EDIT_TRANSFER } from './';

import * as S from './style';

import TableIcon from '@svgIcons/datastream/table.svg';
import Checkbox from '@/components/Common/Checkbox';
import { isValueExist } from '@/utils/utils';
import { FIELD_PANEL_KEY } from '@/components/Dashboard/common/WidgetSettingPanel/reactOptions/consts';
import { fromMetricPanelFormat, toMetricPanelFormat } from './utils';

export const ARCHITECTURE_LEVELS = [
    'adAccount',
    'campaign',
    'adSet',
    'ad',
    'report',
];

export default {
    name: 'ArchitectueTable',
    props: {
        metricList: {
            type: Array,
            default: R.always([]),
        },
        onUpdateMetricWithCheck: {
            type: Function,
        },
        isAnalytic: Boolean,
        selectedSources: {
            type: Array,
        },
        selectedArchLevels: {
            type: Array,
        },
        page: {
            type: String,
        },
    },
    computed: {
        disabled() {
            return this.page === EDIT_TRANSFER;
        },
        options() {
            const hasNaver = R.any(
                R.propEq('channel', 'naver'),
                this.selectedSources
            );

            if (hasNaver) {
                return [...ARCHITECTURE_LEVELS, 'keyword'];
            }

            return ARCHITECTURE_LEVELS;
        },
    },
    methods: {
        renderCheckboxes() {
            return this.options.map((level) => {
                return (
                    <S.TableBreakdownCheckItem>
                        <Checkbox
                            value={this.selectedArchLevels.some(
                                (v) => v === level
                            )}
                            onInput={(value) => {
                                if (this.disabled) return;
                                this.$emit(
                                    'setArchLevels',
                                    value
                                        ? [...this.selectedArchLevels, level]
                                        : R.without(
                                              [level],
                                              this.selectedArchLevels
                                          )
                                );
                            }}
                        />
                        {this.$t(`METRICS.${level}`)}
                    </S.TableBreakdownCheckItem>
                );
            });
        },
    },
    mounted() {
        const selectedMetrics = this.metricList.filter(R.prop('selected'));

        if (
            isValueExist(selectedMetrics) &&
            !this.selectedArchLevels.includes('report')
        ) {
            this.$emit('setArchLevels', [...this.selectedArchLevels, 'report']);
        }
    },
    render() {
        const hasReport = this.selectedArchLevels.includes('report');
        return (
            <S.TableWrapper>
                <S.TableTitleWrapper>
                    <TableIcon />
                    {this.$t('WIDGET.widget_type_pivot')}
                </S.TableTitleWrapper>
                <S.TableBreakdownWrapper disabled={this.disabled}>
                    {this.renderCheckboxes()}
                </S.TableBreakdownWrapper>
                {hasReport && (
                    <MultiMetric
                        panelKey={FIELD_PANEL_KEY.DATASTREAM_METRIC()}
                        currentList={this.metricList.map(toMetricPanelFormat)}
                        canEditCustomMetric={false}
                        selectedSource={this.selectedSources}
                        isAnalytic={this.isAnalytic}
                        isForDatastream={true}
                        hideCustomTab={true}
                        onUpdate={(v) => {
                            const updated = v.map(fromMetricPanelFormat);
                            this.onUpdateMetricWithCheck(updated);
                        }}
                    />
                )}
            </S.TableWrapper>
        );
    },
};
